// 分包付款
import request from '@/api/request'
import download from '@/api/download'

export function add(data) {
  return request({
      url: '/market-service/epc/balance/subpackPay/add',
      method: 'post',
      data
  })
}

export function edit(data) {
  return request({
      url: '/market-service/epc/balance/subpackPay/update',
      method: 'post',
      data
  })
}

export function fetchDetail(data) {
  return request({
      url: `/market-service/epc/balance/subpackPay/query/${data.id}`,
      data
  })
}

export function fetchDetailByPid(data) {
  return request({
      url: `/market-service/epc/balance/subpackPay/queryByPid/${data.id}`,
      data
  })
}

// 下载模版
export function downloadTemplate() {
  return download({
      url: '/market-service/epc/balance/subpackPay/export/template',
  })
}
// 导出
export function exportFile(params) {
  return download({
      url: `/market-service/epc/balance/subpackPay/export/${params.id}`,
  })
}

